import { createGlobalStyle } from 'styled-components';
import SamsungOne200 from '@theme/assets/fonts/SamsungOne-200.ttf';
import SamsungOne300 from '@theme/assets/fonts/SamsungOne-300.ttf';
import SamsungOne400 from '@theme/assets/fonts/SamsungOne-400.ttf';
import SamsungOne500 from '@theme/assets/fonts/SamsungOne-500.ttf';
import SamsungOne600 from '@theme/assets/fonts/SamsungOne-600.ttf';
import SamsungOne700 from '@theme/assets/fonts/SamsungOne-700.ttf';
import SamsungOne800 from '@theme/assets/fonts/SamsungOne-800.ttf';
export const ResetCSS = createGlobalStyle `
  * {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    box-sizing: border-box;
    font-family: 'SamsungOne, sans-serif';
  }

  @font-face {
    font-family: 'SamsungOne';
    src: url(${SamsungOne200}) format('truetype');
    font-weight: 200;
  }

  @font-face {
    font-family: 'SamsungOne';
    src: url(${SamsungOne300}) format('truetype');
    font-weight: 300;
  }

  @font-face {
    font-family: 'SamsungOne';
    src: url(${SamsungOne400}) format('truetype');
    font-weight: 400;
  }

  @font-face {
    font-family: 'SamsungOne';
    src: url(${SamsungOne500}) format('truetype');
    font-weight: 500;
  }

  @font-face {
    font-family: 'SamsungOne';
    src: url(${SamsungOne600}) format('truetype');
    font-weight: 600;
  }

  @font-face {
    font-family: 'SamsungOne';
    src: url(${SamsungOne700}) format('truetype');
    font-weight: 700;
  }

  @font-face {
    font-family: 'SamsungOne';
    src: url(${SamsungOne800}) format('truetype');
    font-weight: 800;
  }

  html,
  #root {
    font-size: 62.5%;
    height: 100%;
  }

  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  body {
    line-height: 1;
    height: 100%;
  }

  ol,
  ul {
    list-style: none;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote::before,
  blockquote::after,
  q::before,
  q::after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  button,
  input[type='button'],
  input[type='submit'],
  input[type='reset'],
  input[type='file'],
  select,
  textarea {
    margin: 0;
    padding: 0;
    border: none;
    background: none;
    font: inherit;
    color: inherit;
    line-height: inherit;
    cursor: pointer;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  button {
    display: inline-block;
    padding: 0;
    border: none;
    background: transparent;
    font: inherit;
    color: inherit;
    cursor: pointer;
    line-height: inherit;
  }

  button:focus,
  input:focus,
  select:focus,
  textarea:focus {
    outline: none;
  }

  #root {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px rgba(255, 255, 255, 0.95) inset !important;
    box-shadow: 0 0 0 1000px rgba(255, 255, 255, 0.95) inset !important;
    -webkit-text-fill-color: inherit !important;
    transition: none !important;
    background-color: rgba(255, 255, 255, 0.95) !important;
    color: inherit !important;
    caret-color: inherit !important;
  }
  
  /* Firefox 자동완성 스타일 제거 */
  input:autofill {
    background-color: rgba(255, 255, 255, 0.95) !important;
    color: inherit !important;
  }
`;
//# sourceMappingURL=reset.js.map